export default __webpack_public_path__ + "static/2236-c8cf2dcc931feb55a1f1cc8e7491a9a2.gif";